export type ResearchStatus = "queued" | "running" | "completed" | "failed" | "cancelled";

export type ResearchMode = "standard" | "question";
export type ResearchBlock = "opportunities" | "risks" | "recommendations";
export type ResearchDepth = "concise" | "extensive";

// Gelijk aan STANDARD_TOPICS in research/prompts.py; de API weigert een
// onbekend onderwerp, dus uiteenlopen valt meteen op.
export const STANDARD_TOPICS = [
  "Ruimtelijke plannen en toegestane functies",
  "Bodem en bekende verontreiniging",
  "Water, overstroming en klimaatrisico",
  "Natuur en beschermde gebieden",
  "Erfgoed en archeologie",
  "Bereikbaarheid en omliggende functies",
  "Bekende ontwikkelplannen en publieke besluiten",
];

export const BLOCK_LABELS: Record<ResearchBlock, string> = {
  opportunities: "Kansen",
  risks: "Risico's en beperkingen",
  recommendations: "Aanbevolen vervolgonderzoek",
};

/** What the user chooses when starting a research. */
export type ResearchChoice = {
  mode: ResearchMode;
  question: string;
  topics: string[];
  blocks: ResearchBlock[];
  depth: ResearchDepth;
};

/** What a research was set up to cover, as the API derives it from the brief. */
export type ResearchSetup = ResearchChoice & { leftOutTopics: string[] };

export type ResearchTarget = {
  id: number;
  parcelId?: number | null;
  parcelName: string;
  capturedAt: string;
  profile: Record<string, any>;
};

export type ResearchSource = {
  id: number;
  code: string;
  url: string;
  title: string;
  publisher: string;
  sourceType: string;
  accessedAt: string;
  official: boolean;
  isDocument: boolean;
  filename: string;
  projectLinkState: string;
  documentState: string;
  documentError: string;
  projectFileName?: string | null;
  projectFileUrl?: string | null;
};

export type ProjectLink = {
  id: number;
  title: string;
  url: string;
  description: string;
  publisher: string;
  accessedAt?: string | null;
};

export type ParcelResearch = {
  id: number;
  projectId: number;
  status: ResearchStatus;
  phase: string;
  progressDetail: string;
  extraQuestion: string;
  report: Record<string, any>;
  contextSummary: string;
  errorMessage: string;
  cancelRequested: boolean;
  previousVersionId?: number | null;
  setup: ResearchSetup;
  reportFileUrl?: string | null;
  created: string;
  started?: string | null;
  finished?: string | null;
  targets: ResearchTarget[];
  sources: ResearchSource[];
};
